import React, { useEffect, useState } from 'react';
import NoResultsText from '../../../common/NoResultsText';
import HistoryTable from './HistoryTable';
import { Paper } from '@material-ui/core';

interface Props {
    approvalRecord: any;
}

function HistoryPanel(props: Props) {
    const [approvalHistory, setApprovalHistory] = useState(null);
    const { approvalRecord } = props;

    useEffect(() => {
        const history = Object.keys(approvalRecord.ApprovalHistory).reduce((accumulator, deck) => {
            Object.keys(approvalRecord.ApprovalHistory[deck]).forEach(version => {
                const approval = approvalRecord.ApprovalHistory[deck][version];
                accumulator.push({
                    id: `${deck}:${version}`,
                    deck,
                    version,
                    approver: approval.Approver,
                    approvalTime: approval.Time * 1000
                });
            });
            return accumulator;
        }, [])

        setApprovalHistory(history);
    }, [approvalRecord]);


    return (
        <div>
            {approvalHistory && approvalHistory.length > 0 && <Paper><HistoryTable approvals={approvalHistory} /></Paper>}
            {approvalHistory && approvalHistory.length === 0 && <NoResultsText>No approval history</NoResultsText>}
        </div>
    );
};

export default HistoryPanel;
